import React from "react";
import ReactTable from "react-table";

class ReactTableV6Simple extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            loading: false,
            columns: []
        }

    }

    componentDidMount() {

        this.setState({
                columns: this.props.columns,
                data: this.props.data,
                loading: this.props.loading
            }
        );

    }

    render() {
        return (
            <ReactTable
                data={this.props.data}
                filterable
                loading={this.props.loading}
                columns={this.props.columns}
                defaultPageSize={this.props.defaultPageSize}
                pageSize={this.props.pageSize}
                showPaginationBottom={this.props.showPaginationBottom !== undefined ? this.props.showPaginationBottom : true}
                showPagination={this.props.showPagination !== undefined ? this.props.showPagination : true}
                className="-striped -highlight"
                getTrProps={this.props.getTrProps}
                SubComponent={this.props.SubComponent}
            />
        );

    }

}

export default ReactTableV6Simple;
